import { Navigate, Outlet } from "react-router-dom";

export default function Content({user, redirectLoginUrl}) {
    return (
        <div className="content">
            { !user ? <Navigate to={redirectLoginUrl} /> : <Outlet /> }
        </div>
    )
}